import { createSlice } from "@reduxjs/toolkit";
import VwHastarapordetayDTO from "src/models/PatolojiModul/VwHastarapordetayDTO";
import MapReducerPayloads from "src/models/store/MapReducerPayloads";
import PatolojiNumuneKabulAramaKriterleri from "./PatolojiNumuneKabulAramaKriterleri";
import VwPatolojiLaboratuvarDTO from "src/models/PatolojiModul/VwPatolojiLaboratuvarDTO";
import VwPatolojiTaleponaysonucDTO from "src/models/PatolojiModul/VwPatolojiTaleponaysonucDTO";
import { GridFilterModel } from "@mui/x-data-grid-premium";
import VSonucDosyaWsDTO from "src/models/Alis/VSonucDosyaWsDTO";
import SonucYazdirmaListeRequest from "src/models/Alis/SonucYazdirmaListeRequest";


interface LaboratuvarSonucState {

    openViewer: boolean,
    pdfs: Array<VSonucDosyaWsDTO>,
    raporsorguId: number,
    printSelectedRows: Array<string>,
    directPrint: boolean,
    searchHandler: boolean,
  }

interface IPatolojiLaboratuvar {
    laboratuvarAramaKriterleri: PatolojiNumuneKabulAramaKriterleri;
    searchHandler?: boolean;
    laboratuvarActiveRow: VwPatolojiLaboratuvarDTO;
    tabsValue: string;
    laboratuvarGridFilterModel: GridFilterModel;

    hastaRaporDetayActiveRow: VwHastarapordetayDTO;
    labEditMode: boolean;

    sablonEkleOpen: boolean;
    sablonIslemlerCheck: boolean;
    ekIslemlerOpen: boolean;
    sablonAktarGridFilterModel: GridFilterModel;

    laboratuvarIptalOpen: boolean;
    laboratuvarOnaylaOpen: boolean;
    onaySelectionIds: Array<VwPatolojiLaboratuvarDTO>;
    labDetayliArama: boolean;
    labOnaySorguOpen: boolean;


    onaySonucHandler: boolean;
    onaySonucActiveRow: VwPatolojiTaleponaysonucDTO;

    protokolDegistirOpen: boolean;
    detayOpen: boolean;
    detayMuracaatId: number;

    revizeRaporOpen: boolean;
    state: LaboratuvarSonucState;
};
export const PatolojiLaboratuvarSlice = createSlice<IPatolojiLaboratuvar, MapReducerPayloads<IPatolojiLaboratuvar, {
    setLaboratuvarAramaKriterleri: PatolojiNumuneKabulAramaKriterleri;
    setSearchHandler?: boolean;
    setLaboratuvarActiveRow: VwPatolojiLaboratuvarDTO;
    setTabsValue: string;
    setLaboratuvarGridFilterModel: GridFilterModel;

    setHastaRaporDetayActiveRow: VwHastarapordetayDTO;
    setLabEditMode: boolean;

    setSablonEkleOpen: boolean;
    setSablonIslemlerCheck: boolean;
    setEkIslemlerOpen: boolean;
    setSablonAktarGridFilterModel: GridFilterModel;

    setLaboratuvarIptalOpen: boolean;
    setLaboratuvarOnaylaOpen: boolean;
    setOnaySelectionIds: Array<VwPatolojiLaboratuvarDTO>;
    setLabDetayliArama: boolean;
    setLabOnaySorguOpen: boolean;

    setOnaySonucHandler: boolean;
    setOnaySonucActiveRow: VwPatolojiTaleponaysonucDTO;

    setProtokolDegistirOpen: boolean;
    setDetayOpen: boolean;
    setDetayMuracaatId: number;

    setRevizeRaporOpen: boolean;
    setState: LaboratuvarSonucState,
}>>({
    name: "patolojiLaboratuvar",
    initialState: {
        laboratuvarAramaKriterleri: new PatolojiNumuneKabulAramaKriterleri(),
        searchHandler: true,
        laboratuvarActiveRow: new VwPatolojiLaboratuvarDTO(),
        tabsValue: "1",
        laboratuvarGridFilterModel: { items: [] },

        hastaRaporDetayActiveRow: new VwHastarapordetayDTO(),
        labEditMode: false,

        sablonEkleOpen: false,
        sablonIslemlerCheck: false,
        ekIslemlerOpen: false,
        sablonAktarGridFilterModel: { items: [] },

        laboratuvarIptalOpen: false,
        laboratuvarOnaylaOpen: false,
        onaySelectionIds: new Array<VwPatolojiLaboratuvarDTO>(),
        labDetayliArama: false,
        labOnaySorguOpen: false,

        onaySonucHandler: false,
        onaySonucActiveRow: new VwPatolojiTaleponaysonucDTO(),

        protokolDegistirOpen: false,
        detayOpen: false,
        detayMuracaatId: 0,

        revizeRaporOpen: false,
        state: {
            openViewer: false,
            pdfs: [],
            raporsorguId: 0,
            printSelectedRows: [],
            directPrint: false,
            searchHandler: false
          },
          

        
    },
    reducers: {
        setLaboratuvarAramaKriterleri: (state, action) => {
            state.laboratuvarAramaKriterleri = action.payload
        },
        //Arama kriterlerini doldurduktan sonra api ye gidip veriyi çektiği state
        setSearchHandler: (state, action) => {
            state.searchHandler = action.payload
        },
        setLaboratuvarActiveRow: (state, action) => {
            state.laboratuvarActiveRow = action.payload
        },
        setTabsValue: (state, action) => {
            state.tabsValue = action.payload
        },
        setLaboratuvarGridFilterModel: (state, action) => {
            state.laboratuvarGridFilterModel = action.payload
        },
        setHastaRaporDetayActiveRow: (state, action) => {
            state.hastaRaporDetayActiveRow = action.payload
        },
        setLabEditMode: (state, action) => {
            state.labEditMode = action.payload
        },
        setSablonEkleOpen: (state, action) => {
            state.sablonEkleOpen = action.payload
        },
        setSablonIslemlerCheck: (state, action) => {
            state.sablonIslemlerCheck = action.payload
        },
        setEkIslemlerOpen: (state, action) => {
            state.ekIslemlerOpen = action.payload
        },
        setSablonAktarGridFilterModel: (state, action) => {
            state.sablonAktarGridFilterModel = action.payload
        },
        setLaboratuvarIptalOpen: (state, action) => {
            state.laboratuvarIptalOpen = action.payload
        },
        setLaboratuvarOnaylaOpen: (state, action) => {
            state.laboratuvarOnaylaOpen = action.payload
        },
        setOnaySelectionIds: (state, action) => {
            state.onaySelectionIds = action.payload
        },
        setLabDetayliArama: (state, action) => {
            state.labDetayliArama = action.payload
        },
        setLabOnaySorguOpen: (state, action) => {
            state.labOnaySorguOpen = action.payload
        },
        setOnaySonucHandler: (state, action) => {
            state.onaySonucHandler = action.payload
        },
        setOnaySonucActiveRow: (state, action) => {
            state.onaySonucActiveRow = action.payload
        },
        setProtokolDegistirOpen: (state, action) => {
            state.protokolDegistirOpen = action.payload
        },
        setDetayOpen: (state, action) => {
            state.detayOpen = action.payload
        },
        setDetayMuracaatId: (state, action) => {
            state.detayMuracaatId = action.payload
        },
        setRevizeRaporOpen: (state, action) => {
            state.revizeRaporOpen = action.payload
        },
        setState: (state, action) => {
            state.state = action.payload
        },
    }
});